var map = {
	"./basil-2.jpg": "24Pp",
	"./basil.jpg": "qcLB",
	"./brocoli.jpg": "hI+z",
	"./garlic.jpg": "VI1R",
	"./nuts.jpg": "l3Ri",
	"./pasta-2.jpg": "SsQy",
	"./pasta.jpg": "b8P4",
	"./peppers.jpg": "U5NK",
	"./red-onion.jpg": "Fz1M",
	"./tomatoes.jpg": "eQIr"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4fMc";